import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchTiposChamado, getNomeTipo } from '../api/tiposChamado';

export function useTiposChamado() {
  const location = useLocation();
  const isSolicitante = (location.pathname || '').startsWith('/Solicitante');
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const list = await fetchTiposChamado(isSolicitante);
      setTipos(list);
    } catch (e) {
      setError(e?.message || 'Erro ao carregar tipos');
      setTipos([]);
    } finally {
      setLoading(false);
    }
  }, [isSolicitante]);

  useEffect(() => {
    load();
  }, [load]);

  const getNome = useCallback((tipoVal) => getNomeTipo(tipos, tipoVal), [tipos]);

  return { tipos, loading, error, getNome, refetch: load };
}
